/**
* @author wangjunfeng
*/

// TODO 协同平台header

<script type="jsx">
import { mapGetters } from 'vuex'
import SyHeader from '../header'
import cacheRequest from '../../../utils/cached-request'
import createDOMPurify from 'dompurify'
import HeaderProcessPopover from '../header-process-popover'
import syImFn from '../im/index'
import syIm from '../im/im.vue'
import response from '../../../utils/response'
import i18n from './i18n'
import Cookies from 'js-cookie'
import apis from './api'

const DOMPurify = createDOMPurify(window)
const pageText = window.fe.getPageText(i18n)
export default {
  components: { SyHeader, HeaderProcessPopover, syImFn, syIm },
  props: {
    templateApi: {
      type: Object,
      default: () => ({})
    },
    // template取值key
    templateKeys: {
      type: Object,
      default: () => {
        return {
          'logoKey': 'logoUrl', // logo
          'headKey': 'purchaserHead', // 头部
          'linkKey': 'logoLink' // logo跳转
        }
      }
    },
    hideBottom: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      template: {},
      languagePart: {
        languageOpt: [],
        usedLanguage: '',
        visible: false
      },
      i18n,
      helpCenterEnabled: false,
      headerProcessPopoverVisible: false
    }
  },
  watch: {
    visible () {
      this.headerProcessPopoverVisible = true
    }
  },
  computed: {
    isPortal () {
      return this.routerPath === '/portal'
    },
    /*headerProcessPopoverVisible () {
      console.log(!!this.visible, 'this.visible')
      return !!this.visible
    },*/
    routerPath () {
      // 菜单所属code，非列表页定位菜单使用
      // let menuCode = this.$route.query.menuCode || this.$route.meta.menuCode
      // let path = menuCode ?? this.$route.path
      const path = this.$route.path
      let arr = path.split('')
      // 适配路由末尾带/而无法展开默认
      return arr[arr.length - 1] === '/' ? arr.slice(0, arr.length - 1).join('') : path
    },
    ...mapGetters(['userInfo', 'applicationClassifyList', 'allMenu', 'visible'])
  },
  created () {
    this.getTemplate()
    this.syncLanguage()
    this.getLanguageList()
    this.getHelpCenterConfig()
  },
  methods: {
    // 页面配置信息
    async getTemplate () {
      const timeInterval = 24 * 60 * 60 * 1000 // 缓存时间
      const res = await cacheRequest(this.templateApi, null, false, null, null, timeInterval)
      if (res.success || res.code === 'success') {
        this.template = res.content
      }
    },
    // 获取语言列表
    async getLanguageList () {
      let api = apis.languageConfig
      let res = await response(this.$http(api.type, api.url))
      if (res.isOk) {
        this.languagePart.languageOpt = res.content
        this.$store.commit('languageSetList', this.languagePart.languageOpt)
      } else if (this.languagePart.usedLanguage) {
        this.$message.error(this.i18n[this.languagePart.usedLanguage].failGetLanguage)
      }
    },
    async getHelpCenterConfig () {
      let api = apis.helpCenterConfig
      let params = {appCode: 'knowledge_management'}
      let result = await response(this.$http(api.type, api.url, params))
      if (result.code === 'success' && result.content) {
        this.helpCenterEnabled = result.content
      }
    },
    // 根据Cookie同步当前所使用的语言
    syncLanguage () {
      let code = window.fe.language
      if (code) {
        this.languagePart.usedLanguage = code
      }
    },
    menuItemUrl (item) {
      let path = item['url']
          ? item['url']
          : item.appMenuList[0].saasMenuModels ? item.appMenuList[0].saasMenuModels[0]?.url : ''
      if (path?.indexOf('tailor') > -1) {
        // 去掉拓展坞路由标识参数，得到真实跳转路径
        path = `/tailor/#${path.replace(path.includes('/tailor_router') ? '/tailor_router' : '/tailor_supplier', '')}`
      }
      return path
    },
    toFirstMenu (item) {
      // portal页 取 url
      let path = item['url']
          ? item['url']
          : item.appMenuList[0].saasMenuModels ? item.appMenuList[0].saasMenuModels[0]?.url : ''
      if (path?.indexOf('tailor') > -1) {
        // 去掉拓展坞路由标识参数，得到真实跳转路径
        path = `/tailor/#${path.replace('/tailor_router', '')}`
      }
      if (this.routerPath === path) return
      if (this.isTailor(path)) {
        window.location.href = path // 拓展坞跳转方式
      } else {
        this.$router.push(path) // saas跳转方式
      }
      this.isTailor(path)
          ? window.location.href = path // 拓展坞跳转方式
          : this.$router.push(path) // saas跳转方式
    },
    // 拓展坞
    isTailor (path) {
      return path.includes('tailor')
    },
    close () {
      this.syncLanguage()
      this.languagePart.visible = false
    },
    loginOut () {
      this.$syRouter && this.$syRouter.reset()
      window.location.href = '/userauth/userLogout/logout?clientType=' + window.fe.project
    },
    // 场景
    applicationRender () {
      const { applicationClassifyList, allMenu, routerPath, isPortal } = this
      return (
          <ul class='syue-right application-list font-color-primary syue-clr'>
            {
              applicationClassifyList && applicationClassifyList?.length
                  ? applicationClassifyList.map((appItem, appIndex) => {
                    return (
                        <li
                            class={[
                              'application-item font-color-primary-light-9',
                              {'current': allMenu[routerPath]?.applicationClassifyId === appItem.id || (isPortal && appIndex === 0)}
                            ]}
                            // on-click={this.toFirstMenu.bind(null, appItem)}
                        >
                          {
                            this.isTailor(this.menuItemUrl(appItem))
                              ? <a href={this.menuItemUrl(appItem)}
                                   class={(allMenu[routerPath]?.applicationClassifyId === appItem.id || (isPortal && appIndex === 0)) && 'font-color-primary'}>{appItem.name}</a>
                              : <router-link
                                  class={(allMenu[routerPath]?.applicationClassifyId === appItem.id || (isPortal && appIndex === 0)) && 'font-color-primary'}
                                  to={this.menuItemUrl(appItem)}>{appItem.name}</router-link>
                          }

                          {/*<span class={{
                      'font-color-primary': allMenu[menuCode || routerPath]?.applicationClassifyId === appItem.id || (isPortal && appIndex === 0)
                    }}>{appItem.name}</span>*/}
                        </li>
                    )
                  })
                  : null
            }
          </ul>
      )
    },
    languageDialog () {
      return (
          this.languagePart.visible
              ? <el-dialog
                  title={i18n[this.languagePart.usedLanguage].switchLanguage}
                  visible={this.languagePart.visible}
                  before-close={this.close}
                  width="360px"
                  top="50vh"
                  custom-class="switch-language-dialog"
                  append-to-body
              >
                <div class="language-select-title">{i18n[this.languagePart.usedLanguage].chooseLanguage}</div>
                <el-select
                    v-model={this.languagePart.usedLanguage}
                    size="mini"
                    class="language-select"
                >
                  {
                    this.languagePart.languageOpt.map(item => {
                      return (
                          <el-option
                              key={item.code}
                              label={item.desc}
                              value={item.code}
                          />
                      )
                    })
                  }
                </el-select>
                <div slot="footer" class="language-dialog-footer">
                  <el-button on-click={this.close}>{i18n[this.languagePart.usedLanguage].cancel}</el-button>
                  <el-button
                      type="primary"
                      on-click={this.changeCookie.bind(null, this.languagePart.usedLanguage)}
                  >{i18n[this.languagePart.usedLanguage].determine}</el-button>
                </div>
              </el-dialog>
              : null
      )
    },
    // 根据租户选择的语言来更改cookie
    changeCookie (code) {
      // Cookies.set('language', code, { path: '/purchaser' })
      this.$syRouter && this.$syRouter.reset()
      Cookies.set('language', code)
      this.close()
      location.reload()
    },
    updateHeaderProcessPopoverVisible (visible) {
      this.headerProcessPopoverVisible = visible
    }
  },
  render () {
    const imgHost = window.Vue.filter('imgHost')
    const { userInfo, languagePart } = this
    const changeVisible = () => {
      this.$set(this.languagePart, 'visible', true)
    }
    // console.log(syImgUrl)
    return (
        <SyHeader class='collaboration-platform__header'>
          <div class='header-top__wrapper'>
            <div
                class='syue-clr header-top__inner'
            >
              <div class='inner-fun__wrap syue-right'>
                <div class='line'></div>
                {/* 设置 */}
                <div class='fun-item'>
                  <el-popover
                      placement="bottom-end"
                      trigger="click"
                      popper-class="collaboration-platform__header-popover"
                      width="168"
                  >
                    <div class="user-content syue-clr">
                      <p class="avatar-wrap">
                        <img src={`${this.syImgUrl}158892365479451958.svg`} alt=""/>
                      </p>
                      <div class="info-wrap">
                        <div class="user-name-container">
                          <p class="user-name"
                             title={userInfo.name || userInfo.loginName || userInfo.purchaserName}>{userInfo.name || userInfo.loginName || userInfo.purchaserName}</p>
                        </div>
                        {
                          languagePart.usedLanguage && (
                              <div class="handle-wrap">
                                {/* 账户设置 */}
                                <div class="account-setting">
                                  <router-link
                                    to={
                                      window.fe.project === 'purchaser'
                                        ? '/account/info'
                                        : '/account/personal-info'
                                    }
                                  ><i class="el-icon-user"></i>{pageText.accountSetup}
                                  </router-link>
                                </div>
                                {/* 多语言 */}
                                {
                                  languagePart.languageOpt?.length > 1 && (
                                      <el-button
                                          type="text"
                                          onClick={changeVisible.bind()}
                                          class="switch-language"
                                      >
                                        <i class="iconfont">&#xe702;</i>
                                        <span>{pageText.switchLanguage}</span>
                                      </el-button>
                                  )
                                }
                                {/* 帮助中心 */}
                                {
                                  this.helpCenterEnabled && <router-link
                                      to={{
                                        path: '/help/list',
                                        query: {
                                          buriedPoint: `${JSON.stringify({
                                            searchBuriedPoint: 'd35',
                                            questionClassification: 'd38',
                                            toViewDetails: 'd41',
                                            enterHelpCenter: 'd44'
                                          })}`
                                        }
                                      }}
                                  >
                                    <el-button type="text">
                                      <i class="iconfont">&#xe735;</i>
                                      <span>{pageText.helpCenter}</span>
                                    </el-button>
                                  </router-link>
                                }
                                {/* 偏好设置 只有采购商端展示偏好设置*/}
                                {
                                  window.fe.project === 'purchaser' && (<div class="account-setting">
                                    <router-link
                                      to="/account/preferences"
                                    ><i class="el-icon-setting"></i>{pageText.preferences}
                                    </router-link>
                                  </div>)
                                }
                                <div class="line"></div>
                                {/* 退出登录 */}
                                <div class="exit">
                                  <span on-click={this.loginOut}>
                                    <i class="el-icon-switch-button"></i>{pageText?.logOut}
                                  </span>
                                </div>
                              </div>
                          )
                        }
                      </div>
                    </div>
                    <p
                      class="trigger-icon"
                      slot="reference"
                      on-click={this.getLanguageList}
                    >
                      <i class="iconfont">&#xe78c;</i><em>{pageText?.settings}</em>
                    </p>
                  </el-popover>
                </div>
                {/* 异步任务 */}
                <div class='fun-item'>
                  <header-process-popover
                      show={this.headerProcessPopoverVisible}
                      ref="process"
                      on={{['update:show']: this.updateHeaderProcessPopoverVisible}}
                  >
                    <span class='item-label'>{pageText?.taskProcess}</span>
                  </header-process-popover>
                </div>
                {/* IM */}
                <div class='fun-item'>
                  <syIm
                      clientType = {window.fe.project || 'purchaser'}
                      messageBoard = {true}
                      showContentList = {true}
                      messageBoardType = 'text'
                  />
                </div>
              </div>
              {
                this.template[this.templateKeys['headKey']] && (
                    <div
                        class='inner-html__wrap'
                        domPropsInnerHTML={DOMPurify.sanitize(this.template[this.templateKeys['headKey']], {ADD_ATTR: ['target']})}
                    ></div>
                )
              }
            </div>
          </div>
          {/* 场景 */}
          {
            !this.hideBottom && (
              <div class='header-content__wrapper'>
                <div class='header-content__inner syue-clr'>
                  <div class='header-logo syue-left'>
                    {
                      this.template[this.templateKeys['linkKey']]
                        ? (
                            <a href={this.template[this.templateKeys['linkKey']]} target="_blank">
                              <img src={imgHost(this.template[this.templateKeys['logoKey']])} alt=''/>
                            </a>
                        )
                        : (<img src={imgHost(this.template[this.templateKeys['logoKey']])} alt=''/>)
                    }
                  </div>
                  {this.applicationRender()}
                </div>
              </div>
            )
          }
          { this.languageDialog() }
        </SyHeader>
    )
  }
}
</script>

<style scoped lang="scss">
.collaboration-platform__header {
  .header-top__wrapper {
    background-color: #2B374E;
    min-height: 32px;
    font-size: 12px;
    box-sizing: border-box;
    .header-top__inner {
      padding: 0 16px;
    }
    .inner-fun__wrap {
      padding-left: 20px;
      .line {
        width: 1px;
        height: 16px;
        background-color: rgba(255, 255, 255, .2);
        margin-right: 20px;
        float: left;
        margin-top: 8px;
      }
    }
    .fun-item {
      height: 32px;
      line-height: 32px;
      float: right;
      &:hover * {
        color: rgba(255, 255, 255, .8);
      }
      .item-label {
        margin-left: 2px;
      }
      & + .fun-item {
        margin-right: 20px;
      }
    }
    ::v-deep .trigger-icon.p-header__process__icon {
      border: none;
      padding: 0;
      height: 32px;
      line-height: 32px;
      &:hover * {
        color: rgba(255, 255, 255, .8);
      }
      * {
        vertical-align: middle;
        color: #fff;
        line-height: 1;
      }
    }
    ::v-deep .sy-im {
      &:hover {
        em,
        span {
          color: currentColor;
        }
      }
      .sy-im-list {
        color: #fff;
      }
    }
  }
  .header-content__wrapper {
    height: 40px;
    background-color: #fff;
    .header-content__inner {
      width: 100%;
      height: 100%;
      padding: 0 16px;
      box-sizing: border-box;
    }
    .header-logo {
      height: 30px;
      padding-top: 5px;
      img {
        height: 100%;
      }
    }
    .application-list {
      .application-item {
        float: left;
        font-size: 14px;
        line-height: 40px;
        height: 40px;
        cursor: pointer;
        &.current {
          background-color: currentColor;
        }
        &:hover {
          background-color: currentColor;
        }
        span,
        a {
          color: #242f57;
          display: block;
          padding: 0 16px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.collaboration-platform__header {
  .inner-html__wrap {
    font-size: 12px;
    line-height: 32px;
    h1 {
      float: left;
      color: #fff;
    }
    .header-link {
      float: right;
      color: #fff;
      & + .header-link {
        margin-right: 24px;
      }
    }
  }
  .trigger-icon {
    line-height: 32px;
    height: 32px;
    * {
      color: #fff;
      vertical-align: middle;
    }
    em {
      margin-left: 2px;
    }
    &:hover * {
      color: currentColor;
    }
  }
}
.collaboration-platform__header-popover {
  padding: 0;
  .trigger-icon {
    font-size: 16px;
  }
  .avatar-wrap {
    width: 40px;
    height: 40px;
    margin: 17px auto 0 auto;
    box-sizing: border-box;
    border: 2px solid #eee;
    border-radius: 50%;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .info-wrap {
    font-size: 12px;
    line-height: 1;
    color: #333;
    padding: 3px 0;
    box-sizing: border-box;
  }
  .user-name-container {
    margin: 8px auto 10px auto;
    padding-bottom: 15px;
    width: 168px;
    border-bottom: 1px solid #EEEEEE;
    .user-name {
      text-align: center;
      max-width: 100px;
      line-height: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      margin: 0 auto;
    }
  }
  .handle-wrap {
    margin-top: 10px;
    font-size: 0;
    span,
    a {
      color: #666;
      display: inline-block;
      padding-right: 8px;
      cursor: pointer;
      font-size: 12px;
      &:hover {
        color: currentColor;
      }
      & + span {
        padding-left: 8px;
        padding-right: 0;
        border-left: 1px solid #eee;
      }
      & + a {
        padding-left: 8px;
        padding-right: 0;
        border-left: 1px solid #eee;
      }
    }
    i {
      margin-left: 10px;
      margin-right: 10px;
      font-size: larger;
    }
    .account-setting {
      margin-top: 3px;
    }
    .switch-language {
      padding-bottom: 0;
    }
    .line {
      width: 90%;
      height: 1px;
      margin: 12px auto 0 auto;
      background-color: #EEEEEE;
    }
    .exit {
      margin: 10px 0;
    }
  }
}
</style>
